import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { HttpClient } from "src/com/sixdee/crbtportal/utils/httpclient/httpclient";
import { POST } from "../../api";
import { SixdeeCRBTAPI } from "../../sixdeecrbtapi";
import { RewardPointGenerateTokenRequest } from "./rewardpointgeneratetokenrequest";



export class RewardPointGenerateTokenAPI extends SixdeeCRBTAPI<RewardPointGenerateTokenRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    { 
        return "auth-service/selfcare/auth/generate-token";
    }

    getRequestData()
    {
         return { 
            msisdn: this.getRequest().getRewardPointGenerateTokenRequest().getMsisdn(),
            encryptedPassword: "Ki/WTtIOcFTWtVowS/0Xfw=="
         };
         
         
    }

    getBASEURL(): string
    {
        return this.getContext().getProperty().getRewardPointGenerateTokenURL() + 
            this.getAPIURL();
    }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/rewardpoint/rewardpointgeneratetoken/rewardpointgeneratetokenapi.tsx